import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as actions from './actions'
import * as getters from './getters'
import * as search from './modules/search'
import * as autocomplete from './modules/autocomplete'
import * as app from './modules/app'
import * as filters from './modules/filters'
import * as dateFilters from './modules/date-filters'
import dateFilterPlugin from './plugins/date-filters'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    app,
    search,
    autocomplete,
    filters,
    dateFilters
  },
  plugins: [dateFilterPlugin],
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js